import type { PartyUpdate, PartyUpdateInput } from 'generated/gql';

const mapPartyUpdateToPartyUpdateInput = (partyUpdate: PartyUpdate): PartyUpdateInput => ({
  partyUpdateId: partyUpdate.id,
  date: partyUpdate.date,
  reason: partyUpdate.reason,
});
export { mapPartyUpdateToPartyUpdateInput };
